import apiManager from '../../api/api-manager';
import { genericApiError, isAxiosResponseOk } from '../../api/api-common';
import { DatiFatca, SurveyRisposte } from '../../api/generated/dob';
import { getAPIRequestHeaders } from '../../utils/api-utils';

class AmlFatcaCrsSurveyRepository {
  getAmlSurvey = async (typeAml: string, thunkApi) => {
    const response = await apiManager.amlSurveyApi.getAmlTemplate(
      typeAml,
      getAPIRequestHeaders(thunkApi, { Accept: 'application/json' })
    );

    if (!isAxiosResponseOk(response)) {
      return genericApiError();
    } else {
      return response.data;
    }
  };

  getAmlSurveyResponse = async (idCustomer: string, idIncarico: string, thunkApi) => {
    const response = await apiManager.dobSurveyApi.getAmlAnswers(
      idCustomer,
      idIncarico,
      getAPIRequestHeaders(thunkApi, { Accept: 'application/json' })
    );

    if (!isAxiosResponseOk(response)) {
      return genericApiError();
    } else {
      return response.data;
    }
  };

  getFatca = async (idCustomer: string, idIncarico: string, thunkApi) => {
    const response = await apiManager.dobCustomerApi.getDatiFatcaCrs(
      idCustomer,
      idIncarico,
      getAPIRequestHeaders(thunkApi, { Accept: 'application/json' })
    );

    if (!isAxiosResponseOk(response)) {
      return genericApiError();
    } else {
      return response.data;
    }
  };

  postFatca = async (idCustomer: string, body: DatiFatca, thunkApi) => {
    const response = await apiManager.dobCustomerApi.saveDatiFatcaCrsPost(
      idCustomer,
      body,
      getAPIRequestHeaders(thunkApi, { Accept: 'application/json' })
    );

    if (!isAxiosResponseOk(response)) {
      return genericApiError();
    } else {
      return response.data;
    }
  };

  postAml = async (surveyRisposte: SurveyRisposte, thunkApi) => {
    const response = await apiManager.dobSurveyApi.saveAmlAnswersPost(
      surveyRisposte,
      getAPIRequestHeaders(thunkApi, { Accept: 'application/json' })
    );
    if (!isAxiosResponseOk(response)) {
      return genericApiError();
    } else {
      return response.data;
    }
  };
}

const amlFatcaCrsSurveyRepository = new AmlFatcaCrsSurveyRepository();
export default amlFatcaCrsSurveyRepository;
